import "@hotwired/turbo-rails"
import "./controllers"
import "./channels"
import { initializeEmblaCarousel } from "./embla_carousel"
import { setupLazyLoading } from "./lazyLoad"
import { setupBackgroundLazyLoading } from "./lazyLoadBackground"
import { setupLazyScriptLoading } from "./lazyScriptLoad"
import { loadJsOnUserInteraction } from "./loadJsOnUserInteraction"
import { initializeAdminWidget } from "./initializeAdminWidget"

document.addEventListener('turbo:load', () => {
    const dataPage = document.body.getAttribute('data-page');
    if (dataPage !== 'hotels/show' && dataPage !== 'hotels/preview' ) {
        initializeEmblaCarousel();
    }

    // Set up lazy loading when user interacts
    loadJsOnUserInteraction(() => {
        setupLazyLoading();
        setupBackgroundLazyLoading();
        setupLazyScriptLoading();
        initializeAdminWidget();
    });
});